import { map } from 'lodash-es';
import { Component } from 'react';
import { HttpService } from '../services';

export default class Administration extends Component {
	constructor(props) {
		super(props);

		this.columns = [
			{ key: 'first_name', label: 'Ime' },
			{ key: 'last_name', label: 'Prezime' },
		];

		this.tableActions = [
			{
				key: 'edit',
				action: (item) => {
					debugger;
				},
				icon: '',
				label: 'Uredi',
			},
			{
				key: 'delete',
				action: (item) => {
					debugger;
				},
				icon: '',
				label: 'Obriši',
			},
		];

		this.state = {
			showRegister: true,
		};

		this.httpService = new HttpService();
		this.tempFetch();
	}

	onRegisterClicked = async (event) => {
		event.preventDefault();

		const form = event.target;
		const resource = {
			email: form.elements['email'].value,
			passphrase: form.elements['passphrase'].value,
		};
		// const authResponse = await this.httpService.authAsync(resource);
		// if (authResponse.ok) {
		// 	const auth = await authResponse.json();
		const bookingsResponse = await this.httpService.getBookingsAsync(
			//auth.token,
			'e8d11db0-f6f2-46cb-94b7-5ad44f1a1f1c',
		);
		if (bookingsResponse.ok) {
			const bookings = await bookingsResponse.json();

			this.setState({
				data: bookings,
				showRegister: false,
			});

			return;
		}
		// }

		// toast.error('You do not belong here!');
	};

	tempFetch = async () => {
		const bookingsResponse = await this.httpService.getBookingsAsync(
			//auth.token,
			'e8d11db0-f6f2-46cb-94b7-5ad44f1a1f1c',
		);
		if (bookingsResponse.ok) {
			const bookings = await bookingsResponse.json();

			this.setState({
				data: bookings,
				showRegister: false,
			});

			return;
		}
	};

	render() {
		const { showRegister, data } = this.state;

		if (showRegister) {
			return <Authenticate onRegisterClicked={this.onRegisterClicked} />;
		}

		return (
			<div>
				<Table
					data={data}
					columns={this.columns}
					actions={this.tableActions}
				/>
			</div>
		);
	}
}

const Authenticate = (props) => {
	const { onRegisterClicked } = props;
	return (
		<div className="register-page">
			<form className="form_wrapper" onSubmit={onRegisterClicked}>
				<div className="form_group">
					<input
						className="input input-text"
						type="email"
						placeholder="E-mail"
						name="email"
						required={true}
					/>
				</div>
				<div className="form_group">
					<input
						className="input input-text"
						type="password"
						placeholder="Passphrase"
						name="passphrase"
						required={true}
					/>
				</div>
				<div className="form_group">
					<button
						className="button button-primary mar-top-lrg"
						type="submit"
					>
						Prijava
					</button>
				</div>
			</form>
		</div>
	);
};

const Table = (props) => {
	const { data, columns, actions } = props;
	return (
		<table>
			<TableHeader columns={columns} />
			<TableBody items={data} columns={columns} actions={actions} />
		</table>
	);
};

const TableHeader = (props) => {
	const { columns } = props;
	return (
		<thead>
			<tr>
				{map(columns, (col) => (
					<th>{col.label}</th>
				))}
			</tr>
		</thead>
	);
};

const TableBody = (props) => {
	const { items, columns, actions } = props;

	return (
		<tbody>
			{map(items, (item) => (
				<TableRow item={item} columns={columns} actions={actions} />
			))}
		</tbody>
	);
};

const TableRow = (props) => {
	const { item, columns, actions } = props;
	return (
		<tr>
			{map(columns, (col) => (
				<td>{item[col.key]}</td>
			))}
			<td>
				{map(actions, (action) => {
					return (
						<button onClick={() => action.action(item)}>
							{action.label}
						</button>
					);
				})}
			</td>
		</tr>
	);
};
